/*
 * @Author: Yolo
 * @Date: 2024-07-02 11:48:59
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-07-02 13:25:17
 * @Desc 渔业协定水域
 */

import L from 'leaflet'
import {
  AreaViewBase,
  type AreaViewBaseOptions,
} from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

class FishAreaSymbol extends AreaViewBase {
  layers: L.Polygon[] = []
  myGroup!: L.LayerGroup<L.Polygon>
  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions>) {
    super(map, options)
    this._data = [
      {
        text: '中韩渔业协定暂定水域',
        color: '#CB147F',
        zoom: [1, 18],
        img: 'url(https://cdn.xplusship.com/img/images/menu.png)',
        latlngs: [
          [37, 123.666666666667],
          [36.3730555555556, 123.181111111111],
          [35.5, 122.198333333333],
          [35.5, 122.031666666667],
          [34, 122.031666666667],
          [34, 122.198333333333],
          [33.3333333333333, 122.683333333333],
          [32.3333333333333, 123.75],
          [32.1833333333333, 123.825],
          [32.1833333333333, 125.416666666667],
          [33.3333333333333, 124.133333333333],
          [34, 124.008333333333],
          [35, 124.125],
          [35.5, 124.5],
          [36.75, 124.5],
          [37, 124.333333333333],
          [37, 123.666666666667],
        ],
      },
      {
        text: '中日渔业协定暂定水域',
        color: '#CB147F',
        zoom: [1, 18],
        img: 'url(https://cdn.xplusship.com/img/images/menu.png)',
        latlngs: [
          [30.6666666666667, 124.168333333333],
          [30, 123.94],
          [29, 123.425],
          [28, 122.798333333333],
          [27, 121.956666666667],
          [27, 125.971666666667],
          [28, 127.251666666667],
          [29, 128.015],
          [30, 128.536666666667],
          [30.6666666666667, 128.435],
          [30.6666666666667, 124.168333333333],
        ],
      },
      {
        text: '中越渔业协定暂定水域',
        color: '#CB147F',
        zoom: [1, 18],
        img: 'url(https://cdn.xplusship.com/img/images/menu.png)',
        latlngs: [
          [17.3938888888889, 107.578611111111],
          [18.1555555555556, 108.338333333333],
          [18.7402777777778, 107.6975],
          [19.1358333333333, 107.6975],
          [19.7166666666667, 108.341666666667],
          [20, 108.708888888889],
          [20, 107.961666666667],
          [19.8761111111111, 107.961666666667],
          [19.8761111111111, 107.483333333333],
          [20, 107.483333333333],
          [20, 107.128055555556],
          [19.5519444444444, 106.621388888889],
          [18.6666666666667, 106.621388888889],
          [18.3161111111111, 106.885555555556],
          [18, 107.031944444444],
          [17.3938888888889, 107.578611111111],
        ],
      },
      {
        text: '中方过渡水域',
        color: '#7848FF',
        zoom: [7, 18],
        img: 'url(https://cdn.xplusship.com/img/images/image.gif)',
        latlngs: [
          [35.5, 121.916667],
          [35, 121.5],
          [34, 121.5],
          [33.333333, 122],
          [31.833333, 123],
          [31.833333, 124],
          [32.333333, 123.75],
          [33.333333, 122.683333],
          [34, 122.198333],
          [34, 122.031667],
          [35.5, 122.031667],
          [35.5, 121.916667],
        ],
      },
      {
        text: '韩方过渡水域',
        color: '#7848FF',
        zoom: [7, 18],
        img: 'url(https://cdn.xplusship.com/img/images/image.gif)',
        latlngs: [
          [35.5, 124.5],
          [35, 124.125],
          [34, 124.008333],
          [33.333333, 124.133333],
          [32.183333, 125.416667],
          [32.183333, 126.75],
          [32.666667, 127],
          [32.408333, 126.283333],
          [32.483333, 125.958333],
          [33.333333, 125.466667],
          [34, 124.583333],
          [34.416667, 124.55],
          [35.5, 124.8],
          [35.5, 124.5],
        ],
      },
    ]
  }

  _show() {
    this._hide()
    this.layers = []
    this.bounds = []
    for (let i = 0; i < this._data.length; i++) {
      const area = this._data[i]
      const zoom = this._map.getZoom()
      if (zoom >= area.zoom[0] && zoom <= area.zoom[1]) {
        const layer = L.polygon(area.latlngs, {
          fill: area.img,
          color: area.color,
          weight: 0,
        }).addTo(this._map)
        if (zoom >= 6) {
          //CommUtils.setPolygonName(layer,area.text, {
          //    repeat: false,
          //    offset: -30,
          //    center: true,//居中
          //    attributes: {
          //        fill: "#000",
          //        'font-weight': '500',
          //        'font-size': '14',
          //        'font-family': "微软雅黑",
          //        'letter-spacing': '6px',
          //    }
          //})
          ;(layer as any).setText(area.text, {
            repeat: false,
            offset: -30,
            center: true, //居中
            attributes: {
              fill: '#000',
              'font-weight': '500',
              'font-size': '14',
              'font-family': '微软雅黑',
              'letter-spacing': '6px',
            },
          })
        }

        this.layers.push(layer)
        for (let j = 0; j < area.latlngs.length; j++) {
          this.bounds.push(area.latlngs[j])
        }
      }
    }

    if (this.layers.length > 0) {
      this.myGroup = L.layerGroup(this.layers)
      this._map.addLayer(this.myGroup)
    }
  }
  _hide() {
    //清除所画区域
    if (this.layers.length > 0) {
      this.myGroup.clearLayers()
      this.layers = []
    }
  }
}

// 实例化工厂方法
const fishAreaSymbol = (map: MyMap, options?: Partial<AreaViewBaseOptions>) =>
  new FishAreaSymbol(map, options)

export { FishAreaSymbol, fishAreaSymbol }
